import React from "react";
import heartGraphic from "../img/heart.png";
import { Container } from "react-bootstrap";

const HeartBar = (): JSX.Element => {
  return (
    <div className="lzk-heart-container p-3" style={{ backgroundColor: "#eeeeee" }}>
      <Container className="text-center">
        Unser <img className="heart" style={{ width: "40px" }} alt={heartGraphic} src={heartGraphic}></img> schlägt für Bildung
      </Container>
    </div>
  );
};

export default HeartBar;
